import styles from './SegmentedGroup.module.scss';
import { VdsIcon, VdsSegmentedButton } from '@volt/volt-extended-components-react';
import { ReactElement, useCallback, useState } from 'react';

export interface SegmentedButtonProps<T extends string> {
  value: T;
  icon: string;
}

interface SegmentedGroupProps<T extends string> {
  items: SegmentedButtonProps<T>[];
  initialValue: T;
  onValueChange: (value: T) => void;
}

export const SegmentedGroup = <T extends string>({
  items,
  initialValue,
  onValueChange,
}: SegmentedGroupProps<T>): ReactElement => {
  const [active, setActive] = useState<T>(initialValue);

  const onInputChange = useCallback(
    (value: T, index: number) => {
      setActive(value);
      onValueChange(value);
    },
    [onValueChange],
  );

  return (
    <div className={styles.container}>
      {items.map(({ value, icon }: SegmentedButtonProps<T>, idx: number) => {
        return (
          <VdsSegmentedButton
            key={idx}
            value={value}
            isActive={value === active}
            onClick={() => onInputChange(value, idx)}
          >
            <VdsIcon svg-icon={icon} />
          </VdsSegmentedButton>
        );
      })}
    </div>
  );
};

export default SegmentedGroup;
